import { defineStore } from 'pinia';
import { POSRegisters } from '@/services/endpoint/pos.service';

export const useShopStore = defineStore('shop', {
  state: () => ({
    name: null,
    shiftId: null,
    branchId: null,
    loggedIn: false,
    // LEGACY, read-only — the branch paper width this browser cached at its last
    // shop entry BEFORE paper width moved to the device (utils/printerSettings.js).
    // initPrinterSettings() reads it once at boot to migrate old tills. The API no
    // longer sends it (branches.bill_paper_width was dropped), so nothing writes it
    // any more; remove once every till has booted a post-2026-09-30 build.
    billPaperWidth: '72mm',
    // delivery platform ที่เลือกตอนเปิด session (key = session token) — platform ผูกที่
    // ระดับ order (BE) จึงต้องพกไว้ฝั่ง FE จนถึงตอนส่งครัว (persist กัน reload หน้า)
    // docs/delivery-platform-pricing.md
    sessionPlatforms: {},
    // เปิด/ปิดระบบ delivery platform (settings กลาง) — ซ่อน/โชว์เมนู "ออเดอร์ Platform" บน POS
    deliveryPlatformEnabled: false
  }),
  actions: {
    async enterShop(branchId) {
      try {
        const res = await POSRegisters.enterShop(branchId);
        this.loggedIn = true;
        this.name = res.data.data.branch_name;
        this.shiftId = res.data.data.id;
        this.branchId = branchId;
        this.deliveryPlatformEnabled = !!res.data.data.delivery_platform_is_enabled;
        return res;
      } catch (err) {
        this.$reset();
        throw err;
      }
    },
    // refresh flag/ชื่อร้านจาก BE โดยไม่แตะสถานะ login — POSLayout เรียกตอน mount
    // เพื่อให้ toggle จากหน้าตั้งค่า (เช่น delivery_platform_is_enabled) sync มาถึง POS
    // ที่เข้าร้านค้างอยู่ โดยไม่ต้องออก/เข้าร้านใหม่ (error = เงียบ ไม่ reset กันโดนดีดเพราะ network แว้บ)
    async refreshShopContext() {
      if (!this.loggedIn || !this.branchId) return;
      try {
        const res = await POSRegisters.enterShop(this.branchId);
        this.name = res.data.data.branch_name;
        this.shiftId = res.data.data.id;
        this.deliveryPlatformEnabled = !!res.data.data.delivery_platform_is_enabled;
      } catch (err) { /* คงค่าเดิมไว้ */ }
    },
    outShop() {
      this.$reset();
    },
    setSessionPlatform(token, info) {
      this.sessionPlatforms[token] = info;
    },
    getSessionPlatform(token) {
      return this.sessionPlatforms[token] || null;
    },
    clearSessionPlatform(token) {
      delete this.sessionPlatforms[token];
    },
    clearShopState() {
      this.$reset();
    }
  },
  persist: true
});
